module.exports = __webpack_public_path__ + "img/logo.ef47352f.png";